/**
 * @generated SignedSource<<66a84bed9428cdb262164d3d5a5ff40a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAbtestScenarioPageGroupInput = {
  clientMutationId?: string | null;
  abtestScenarioPageGroupId: string;
};
export type FunnelABTestGroupTableActions_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteAbtestScenarioPageGroupInput;
};
export type FunnelABTestGroupTableActions_DeleteMutationVariables = FunnelABTestGroupTableActions_DeleteMutation$variables;
export type FunnelABTestGroupTableActions_DeleteMutation$data = {
  readonly deleteAbtestScenarioPageGroup: {
    readonly deletedAbtestScenarioPageGroupId: string;
  } | null;
};
export type FunnelABTestGroupTableActions_DeleteMutationResponse = FunnelABTestGroupTableActions_DeleteMutation$data;
export type FunnelABTestGroupTableActions_DeleteMutation = {
  variables: FunnelABTestGroupTableActions_DeleteMutationVariables;
  response: FunnelABTestGroupTableActions_DeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAbtestScenarioPageGroupId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelABTestGroupTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAbtestScenarioPageGroupPayload",
        "kind": "LinkedField",
        "name": "deleteAbtestScenarioPageGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelABTestGroupTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAbtestScenarioPageGroupPayload",
        "kind": "LinkedField",
        "name": "deleteAbtestScenarioPageGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedAbtestScenarioPageGroupId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "03b692267811952b7d69856a123b8f31",
    "id": null,
    "metadata": {},
    "name": "FunnelABTestGroupTableActions_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FunnelABTestGroupTableActions_DeleteMutation(\n  $input: DeleteAbtestScenarioPageGroupInput!\n) {\n  deleteAbtestScenarioPageGroup(input: $input) {\n    deletedAbtestScenarioPageGroupId\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2e914bac7860aaeba790c29044c0fb4";

export default node;
